import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { getDefaultPathForUser, paths } from '@/paths'
import { Page as NotFoundPage } from '@/pages/not-found'
import { useUser } from '@/hooks/use-user'
import { AuthenticationGuard } from '@/components/auth/authentication-guard'

import { route as authRoute } from './auth'
import { route as dashboardRoute } from './dashboard'

export function HomeRedirect() {
	const { user } = useUser()

	const defaultPath = getDefaultPathForUser(user)
	return <Navigate replace to={defaultPath} />
}

export const routes: RouteObject[] = [
	{
		path: paths.home,
		element: (
			<AuthenticationGuard>
				<HomeRedirect />
			</AuthenticationGuard>
		),
	},
	{
		path: 'errors',
		children: [
			{
				path: 'internal-server-error',
				lazy: async () => {
					const { Page } = await import('@/pages/errors/internal-server-error')
					return { Component: Page }
				},
			},
			{
				path: 'not-authorized',
				lazy: async () => {
					const { Page } = await import('@/pages/errors/not-authorized')
					return { Component: Page }
				},
			},
			{
				path: 'not-found',
				lazy: async () => {
					const { Page } = await import('@/pages/errors/not-found')
					return { Component: Page }
				},
			},
			{
				path: 'site-updated',
				lazy: async () => {
					const { Page } = await import('@/pages/errors/site-updated')
					return { Component: Page }
				},
			},
		],
	},
	authRoute,
	dashboardRoute,
	{ path: '*', element: <NotFoundPage /> },
]
